import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

import ReactionsIcon from 'hb-react/shared/components/DesignSystem/Reactions/components/ReactionsIcon';
import ReactionsWrapper from 'hb-react/shared/components/DesignSystem/Reactions/components/ReactionsWrapper';
import IconShareHallow from 'hb-react/shared/icons/ShareHollow';
import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';

import ReactionsSharesDropdown from './ReactionsSharesDropdown';

const ReactionsShares = ({
  content,
  height = '20px',
  onClick, // Keep this name (instead of onShareExternally) for backward compatibility with ReactionsShares
  sharedFrom,
  sharedUrl,
  shareToLiveFeedEnabled,
  shareToLiveFeedUrl,
  shareUrl,
  showFullText = true,
  totalShares = 0,
  width = '20px',
}) => {
  // the button cannot exist if there is no action bound to it
  if (!shareToLiveFeedEnabled && !onClick) {
    return null;
  }

  return (
    <ReactionsWrapper px={0}>
      <ReactionsSharesDropdown
        content={content}
        onShareExternally={onClick}
        shareToLiveFeedEnabled={shareToLiveFeedEnabled}
        shareToLiveFeedUrl={shareToLiveFeedUrl}
        shareUrl={shareUrl}
        sharedFrom={sharedFrom}
        sharedUrl={sharedUrl}
      >
        {({ onClick, ...rest }) => (
          <Box
            onClick={onClick}
            onKeyDown={onEnterOrSpacePress(onClick)}
            role="button"
            tabIndex={0}
            aria-label={__('Share')}
          >
            <ReactionsIcon {...rest} data-testid="reaction-share">
              <IconShareHallow height={height} width={width} />
            </ReactionsIcon>
            {showFullText
              ? __('Share')
              : totalShares > 0 && (
                  <Box display="block" mr={2}>
                    {totalShares}
                  </Box>
                )}
          </Box>
        )}
      </ReactionsSharesDropdown>
    </ReactionsWrapper>
  );
};

export default ReactionsShares;

ReactionsShares.propTypes = {
  content: PropTypes.object,
  onClick: PropTypes.func,
  shareToLiveFeedEnabled: PropTypes.bool,
  shareToLiveFeedUrl: PropTypes.string,
  shareUrl: PropTypes.string,
  sharedFrom: PropTypes.string,
  showFullText: PropTypes.bool,
  totalShares: PropTypes.number,
  height: PropTypes.string,
  width: PropTypes.string,
};
